<template>
  <span>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Trend Data Reset
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-content class="v-list__tile__sub-title" style="white-space: wrap !important;">
              Reset trend data
            </v-list-tile-content>
            <v-card-actions>
              <v-btn class='ml-1 oem-text-color' @click='openTrendDataResetDialog()'>
                Reset
              </v-btn>
            </v-card-actions>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
    <msg-dialog
      ref='trendDataResetDialog'
      v-bind:title='`Confirm`'
      v-bind:msg='trendDataResetText'
    />
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :top='true'
    >
      {{ snackbarText }}
      <v-btn
        class='oem-color-text'
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </span>
</template>

<script>
import msgDialog from './BaseDialog.vue';
import ajax from '../ajax';
// import * as auth from '../auth';

export default {
  name: 'TrendDataReset',

  components: {
    msgDialog,
  },

  props: {
    version: String,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      trendDataResetText: 'Are you sure you want to clear all trend data?',
    };
  },
  methods: {
    openTrendDataResetDialog() {
      this.$refs.trendDataResetDialog
        .pop()
        .then(() => {
          ajax.put('system/trendDataReset', { })
            .then(() => {
              this.$store.refreshData(() => {
                this.snackbar = true;
                this.snackbarText = 'Trend data has been reset';
                this.$store.addEventLog('Trend data reset');
              });
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
              this.$store.addEventLog(`Failed to reset the trend data. Error ${e}`);
            });
        })
        .catch(() => {});
    },
    close() {
      this.trendDataResetDialog = false;
      this.snackbar = true;
      this.snackbarText = 'test';
    },
  },
};
</script>

<style scoped>
    input[type=file] {
        display: none;
    }
</style>
